import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import Switch from '@material-ui/core/Switch';
import { NARRATIVE } from 'constants/types';
import { NarrativeWrapper } from './styles';

class NarrativeSmallCard extends Component {
  constructor(props) {
    super(props);

    const { itemsPreferencesFromSerendipity, data: { id } } = this.props;

    const enabled = !_.find(itemsPreferencesFromSerendipity, item => item.element_type === NARRATIVE && item.element_id === id && !item.enabled);

    this.state = {
      enabled,
      timeClick: null,
    };
  }

  componentDidUpdate() {
    const { enabled } = this.state;

    const { itemsPreferencesFromSerendipity, data: { id } } = this.props;

    const enabledNow = !_.find(itemsPreferencesFromSerendipity, item => item.element_type === NARRATIVE && item.element_id === id && !item.enabled);

    if (enabledNow !== enabled) {
      this.changeEnabledStatus(enabledNow);
    }
  }

  changeEnabledStatus = (enabled) => {
    this.setState({ enabled });
  }

  handleClick = (event) => {
    const { history, data: { id } } = this.props;
    const { timeClick } = this.state;
    const diff = moment().valueOf() - timeClick;
    if (diff < 200 && !window.$(event.target).hasClass('MuiSwitch-input')) {
      history.push(`/narratives/${id}`);
    }
  }

  handleMouseDown = () => {
    this.setState({ timeClick: moment().valueOf() });
  }

  handleChangeEnabled = (event) => {
    const { enableItemFromSerendipity, disableItemFromSerendipity, data: { id } } = this.props;
    this.setState({ enabled: event.target.checked });

    if (event.target.checked) {
      enableItemFromSerendipity(NARRATIVE, id);
    } else {
      disableItemFromSerendipity(NARRATIVE, id);
    }
  }

  printProgress = () => {
    const { data, literals } = this.props;

    if (data.progress === 0) {
      return (<div className='new'>{literals.new}</div>);
    }

    if (data.progress === 100) {
      return (<div className='completed'>{literals.completed}</div>);
    }

    return (<div>{`${data.progress}%`}</div>);
  }

  render() {
    const {
      data, classesList, color, showFooter,
    } = this.props;

    const { enabled } = this.state;

    let banner = (
      <div className='banner_narrative' style={{ backgroundColor: color }}>
        <img src={data.image} alt='' />
      </div>
    );

    if (data.type === 21227760) {
      banner = (<div className='banner_narrative' style={{ backgroundColor: color, backgroundImage: `url(${data.image})` }} />);
    }

    return (
      <NarrativeWrapper className={`${classesList} c2icard ${enabled && data.progress < 100 ? 'enabled' : 'disabled'}`} onClick={this.handleClick} onMouseDown={this.handleMouseDown} image={data.background_image}>
        <div className='header'>
          <div className='section_name' style={{ color: data.section.color }}>{data.section.name}</div>
          <div className='title'>{data.name}</div>
        </div>
        {banner}
        <div className='description'>{data.description}</div>
        {showFooter ? (
          <div className='footer'>
            <div>
              <Switch
                checked={enabled}
                size='small'
                onChange={this.handleChangeEnabled}
                name='check_enabled'
                color='primary'
              />
            </div>
            <div>{this.printProgress()}</div>
          </div>
        ) : null}
      </NarrativeWrapper>
    );
  }
}

NarrativeSmallCard.propTypes = {
  data: PropTypes.object.isRequired,
  classesList: PropTypes.string,
  literals: PropTypes.object.isRequired,
  enableItemFromSerendipity: PropTypes.func.isRequired,
  disableItemFromSerendipity: PropTypes.func.isRequired,
  itemsPreferencesFromSerendipity: PropTypes.array,
  color: PropTypes.string,
  showFooter: PropTypes.bool,
};

NarrativeSmallCard.defaultProps = {
  classesList: '',
  color: '#FF8000',
  itemsPreferencesFromSerendipity: [],
  showFooter: true,
};

export default NarrativeSmallCard;



// WEBPACK FOOTER //
// ./src/components/Cards/NarrativeSmallCard/components/index.jsx